import { Constants } from '@/common/Constants';
import { WaterMetersApi, WaterMonitorsApi, WaterTotalizerCorrectionDynamoItem } from '@/api';
import { ApiUtils } from '@/common/ApiUtils';
import { AxiosResponse } from 'axios';

export class WaterCorrectionsService {
	private static readonly waterMetersApi = new WaterMetersApi();
	private static readonly waterMonitorsApi = new WaterMonitorsApi();

	public static async getTotalizerCorrections(
		entityType?: string,
		entityId?: number,
	): Promise<{
		data?: any;
		error?: string;
	}> {
		if (entityType == null) return { error: 'Entity Type is required to get corrections' };
		if (entityId == null) return { error: 'Entity ID is required to get corrections' };
		if (
			![Constants.ENTITY_TYPE_WATER_METER, Constants.ENTITY_TYPE_WATER_MONITOR].includes(entityType)
		)
			return { error: 'Can only get water corrections for meters and monitors' };
		const totalizerCorrectionsApiCall: () => Promise<
			AxiosResponse<WaterTotalizerCorrectionDynamoItem[]>
		> = async () => {
			return entityType === 'water_meters'
				? await this.waterMetersApi.getMeterTotalizerCorrections(entityId)
				: await this.waterMonitorsApi.getMonitorTotalizerCorrections(entityId);
		};
		try {
			const correctionsResponse = await totalizerCorrectionsApiCall();
			return {
				data: correctionsResponse.data.map(
					(dynamoItem: WaterTotalizerCorrectionDynamoItem) => dynamoItem.data,
				),
			};
		} catch (e) {
			console.log(e);
			const { errorMessage } = ApiUtils.handleApiError(e, 'Failed to load totalizer corrections');
			return { error: errorMessage };
		}
	}
}
